import React from "react";
import { useSelector } from "react-redux";

import { BrandingStore } from "src/store";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
  },
  asset: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
};

const OrgIcon = ({ orgId }) => {
  const branding = useSelector(BrandingStore.selectors.find({ orgId }));
  return (
    <div style={styles.container}>
      <img
        style={styles.asset}
        alt={branding?.favicon_filename || ""}
        src={branding?.favicon_url}
      />
    </div>
  );
};

export { OrgIcon };
